import React from "react";
import {Link} from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

export default class TrialExpireModal extends React.Component {
  render() {
    return (
      <Dialog open={true}>
        <DialogTitle>Your Trial is Expiring Soon</DialogTitle>
        <DialogContent>
          <DialogContentText style={{paddingTop: 16, paddingBottom: 16}}>
            Thank you for using MapPlug! Your free trial ends {this.getExpirationString()}!
          </DialogContentText>
          <DialogContentText>If you need more time to try the system, let us know.</DialogContentText>
          {this.props.accountEditPermission ? this.renderEditorContent() : this.renderNonEditorContent()}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onRequestClose} disabled={false}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  getExpirationString() {
    const {trialDaysRemaining, trialExpiration} = this.props;
    if (trialDaysRemaining === 0) {
      return "today";
    }
    let endDate = trialExpiration.format("MMMM DD, YYYY");
    let dayOrDays = trialDaysRemaining === 1 ? "day" : "days";
    return `in just ${trialDaysRemaining} ${dayOrDays} on ${endDate}`;
  }

  renderEditorContent() {
    return (
      <DialogContentText>
        Visit your{" "}
        <Link to="/account/settings" onClick={this.props.onAccountClick}>
          account settings
        </Link>{" "}
        to set up billing.
      </DialogContentText>
    );
  }

  renderNonEditorContent() {
    return (
      <DialogContentText id="nonEditorContent">
        Enjoying MapPlug? Tell your account owner, {this.props.ownerName}, to set up billing so that you can keep using
        it.
      </DialogContentText>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrialExpireModal/index.jsx